/* istanbul ignore file */
export * from './date-with-ordinal/date-with-ordinal.pipe';
export * from './interpolate/interpolate.pipe';
